



import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const EditEventsPage = () => {
  const [events, setEvents] = useState([]);
  const [errorMsg, setErrorMsg] = useState("");
  const navigate = useNavigate();

  const token = localStorage.getItem("token");

  useEffect(() => {
    if (!token) {
      setErrorMsg("برجاء تسجيل الدخول.");
      return;
    }

    const fetchEvents = async () => {
      try {
        const res = await axios.get(`https://localhost:7136/api/event/organizer/events`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        setEvents(res.data);
      } catch (error) {
        console.error("Error fetching events:", error);
        setErrorMsg("حدث خطأ أثناء تحميل الفعاليات.");
      }
    };

    fetchEvents();
  }, [token]);

  const handleDelete = async (eventId) => {
    const confirmDelete = window.confirm("هل أنت متأكد أنك تريد حذف هذه الفعالية؟");
    if (!confirmDelete) return;

    try {
      await axios.delete(`https://localhost:7136/api/event/${eventId}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      // شيل الحدث من القائمة
      setEvents(events.filter((e) => e.eventId !== eventId));
    } catch (error) {
      console.error("خطأ أثناء حذف الفعالية:", error);
      alert("حدث خطأ أثناء حذف الفعالية.");
    }
  };

  const handleEdit = (eventId) => {
    // عند الضغط على زر التعديل، انتقل إلى صفحة التعديل مع eventId
    navigate(`/editForm/${eventId}`);
  };

  return (
    <div
      className="min-h-screen bg-gray-100 p-8"
      style={{
        backgroundImage: "url('./images/photo6.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="max-w-5xl mx-auto">
        <h1 className="text-3xl font-bold mb-6 text-center text-purple-700">
          تعديل فعالياتك
        </h1>

        {errorMsg && <p className="text-red-600 text-center mb-4">{errorMsg}</p>}

        {events.length === 0 ? (
          <p className="text-center text-gray-500 mt-8">لا توجد فعاليات حاليًا.</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {events.map((event) => (
              <div key={event.id} className="bg-white p-3 rounded-xl shadow-md w-95">
                {event.mediaFileName && (
                  <>
                    {event.mediaFileName.match(/\.(jpg|jpeg|png|gif)$/i) ? (
                      <img
                        src={`https://localhost:7136/uploads/${event.mediaFileName}`}
                        alt={event.title}
                        className="w-full h-36 object-cover rounded-lg mb-4"
                      />
                    ) : event.mediaFileName.match(/\.(mp4|webm|ogg)$/i) ? (
                      <video
                        controls
                        className="w-full h-36 object-cover rounded-lg mb-4"
                        src={`https://localhost:7136/uploads/${event.mediaFileName}`}
                      />
                    ) : null}
                  </>
                )}

                <h2 className="text-xl font-bold text-purple-800">{event.title}</h2>
                <p className="text-gray-600">📍 {event.venue}</p>
                <p className="text-gray-600">💰 {event.ticketPrice} جنيه</p>
                <p className="text-gray-600">🎟️ عدد التذاكر: {event.totalTickets}</p>
                <p className="text-gray-600">
                  🕒 {new Date(event.eventDatetime).toLocaleString()}
                </p>
                {event.description && (
                  <p className="text-gray-700 mt-2">{event.description}</p>
                )}

                <div className="flex justify-between mt-4">
                  <button
                    onClick={() => handleEdit(event.eventId)}
                    className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg"
                  >
                    تعديل
                  </button>
                  <button
                    onClick={() => handleDelete(event.eventId)}
                    className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg"
                  >
                    حذف
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default EditEventsPage;
